import { createFileRoute } from "@tanstack/react-router";
import { dailyBonusQueryOptions } from "~/features/dailyBonus/api";
import { DailyBonusTemplate } from "~/features/dailyBonus/DailyBonusTemplate";

export const Route = createFileRoute("/_authenticated/daily-bonus")({
  // claim(utage_web_daily_bonus)を含むため、hover プリロードでは loader を発火させない。
  // 実ナビゲーション時のみ claim を叩く（Link hover で受取が消費され、本表示で
  // add_point=0 になりモーダルが出ない、という二重発火を防ぐ）。
  preload: false,
  // キャッシュ優先の ensureQueryData ではなく fetchQuery を使う。staleTime:0 と組み合わせ、
  // 再訪のたびフレッシュに claim を叩き直す（サーバが日次 idempotent）。
  loader: ({ context: { queryClient } }) =>
    queryClient.fetchQuery(dailyBonusQueryOptions),
  component: DailyBonusTemplate,
});
